// module
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorIntlBrService } from 'src/app/data/services/mat-paginator-intl-br.service';
import { ArrivalDetailStatusComponent } from 'src/app/ui/components/arrival/arrival-detail-status/arrival-detail-status.component';
import { CardArrivalHistoryComponent } from 'src/app/ui/components/arrival/card-arrival-history/card-arrival-history.component';
import { CloseImageComponent } from 'src/app/ui/components/arrival/close-image/close-image.component';
import { DialogHistoryFilterComponent } from 'src/app/ui/components/arrival/dialog-history-filter/dialog-history-filter.component';
import { GateMonitoringFilterComponent } from 'src/app/ui/components/arrival/gate-monitoring-filter/gate-monitoring-filter.component';
import { HistoryComponent } from 'src/app/ui/components/arrival/history/history.component';
import { CardArrivalComponent } from 'src/app/ui/components/card-arrival/card-arrival.component';
import { MonitoringComponent } from 'src/app/ui/pages/arrival/gates-monitoring/monitoring.component';
import { MaterialModule } from '../app-material.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    MonitoringComponent,
    CardArrivalComponent,
    GateMonitoringFilterComponent,
    ArrivalDetailStatusComponent,
    CloseImageComponent,
    CardArrivalHistoryComponent,
    HistoryComponent,
    DialogHistoryFilterComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatProgressSpinnerModule,
    SharedModule,
  ],
  exports: [MonitoringComponent],
  providers: [
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlBrService }
  ],
})
export class GatesMonitoringModule {}
